// IAS overlay: no paid-features upsell in the admin nav.
const StoreLink = () => null;

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default StoreLink;
